module.exports = __webpack_public_path__ + "media/talking-portrait-default.9b440cc3.mp4";